(function(){
    'use strict'

    angular
    .module('app.contratos')
    .controller('contratos.EditDetalle', EditDetalle);

    EditDetalle.$inject = ['$q', '$scope', '$animationsSrv', '$routeParams','ApiBaseService', 'logger', '$location', 'UserInfoService', 'moment'];

    function EditDetalle($q, $scope, $animationsSrv, $routeParams, ApiBaseService, logger, $location, UserInfoService, moment) {
    
        $animationsSrv.scrollToTop();
        const apiContratos = 'api/Contratos/Detalle'
        const companiaId = UserInfoService.getCompaniaId();

        let vm = this;

        vm.data = {
            moneda:'0',
            tipoImpuesto: 0,
            codigoTarifa: 0,
            servicioId: 0,
            cantidad: 1
        };

       
        vm.contratoId = $routeParams.contrato ? $routeParams.contrato : 0;
        vm.id = $routeParams.id ? $routeParams.id : 0;
        vm.servicios = [];
        vm.indicadores = [];
        vm.contrato = null;

        vm.data.contratoId = vm.contratoId;
        vm.title = 'Detalle Contrato: ' + vm.contratoId;

        const promiseServicios = getComboData(vm.servicios, 'api/Servicios', [companiaId], 'Error al obtener los servicios.');
        const promiseIndicadores = getComboData(vm.indicadores, 'api/Indicadores', null, 'Error al obtener los indicadores.');
        const promiseContrato = getContrato('api/Contratos', [companiaId, vm.contratoId], 'Error al obtener el contrato.');

        get();

        function getComboData(array, apiUrl, params, errorMessage){
            ApiBaseService.remoteController = apiUrl;
            var promise = ApiBaseService.getAll(params)
            .then(function(data){
                array.splice(0);
                array.push(...data);
            })
            .catch(function(error){
                $logger.error(errorMessage);
            }); 
            
            return promise;
        };

        function getContrato(apiUrl, params, errorMessage){
            ApiBaseService.remoteController = apiUrl;
            var promise = ApiBaseService.getAll(params)
            .then(function(data){
                vm.contrato = data;
                console.log(vm.contrato);
            })
            .catch(function(error){
                $logger.error(errorMessage);
            }); 
            
            return promise;
        };

        function get(){

            $q.all([promiseServicios, promiseIndicadores, promiseContrato])
            .then(function(){
                if(vm.id != 0){
                    ApiBaseService.remoteController = apiContratos;
                    var promise = ApiBaseService.getAll([companiaId, vm.contratoId, vm.id]);
    
                    promise
                    .then(function(data){
                        vm.data = data;
                    })
                    .catch(function(error){
                        switch (error.status) {
                            case 401:
                                logger.error('La sesión ha expirado');
                                break;
                        
                            default:
                                logger.error('Hubo un error al obtener el registro: ' + error.data.Message);
                                break;
                        }
                    });               
                }
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sesión ha expirado');
                        break;
                
                    default:
                        logger.error('Hubo un error al obtener los datos: ' + error.data.Message);
                        break;
                }
            }); 

        };

        function doFormValidations()
        {
            validateSelectProperty('moneda');
            validateSelectProperty('tipoImpuesto');
            validateSelectProperty('codigoTarifa');
            validateSelectProperty('servicioId');
        };

        vm.save = function(){

            $scope.submitted = true;

            doFormValidations();

            if($scope.dataForm.$valid){
                if(!vm.data.id){
                    create();
                }
                else if($scope.dataForm.$dirty){
                    update();
                }
                else{
                    logger.info('No has modificado ningún dato!');
                }
            }     
        
        };

        function create() {
            vm.data.cia_codigo = companiaId;
            ApiBaseService.remoteController = apiContratos;
            vm.data.contratoId = vm.contratoId;
            var promise = ApiBaseService.save(vm.data);
            
            promise
            .then(function(response){
                logger.success('Registro creado con éxito.');
                clearData();
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sesión ha expirado');
                        break;
                
                    default:
                        logger.error('Hubo un error al crear el registro: ' + error.data.Message);
                        break;
                }
            });   
        };

        function update(){
            vm.data.cia_codigo = companiaId;
            ApiBaseService.remoteController = apiContratos;
            vm.data.contratoId = vm.contratoId;
            var promise = ApiBaseService.update(vm.data);
            
            promise
            .then(function(response){
                logger.success('Registro modificado con éxito.');
                $location.path('/contratos');
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sesión ha expirado');
                        break;
                
                    default:
                        logger.error('Hubo un error al modificar el registro: ' + error.data.Message);
                        break;
                }
            });   
        };

        function clearData(){
            $scope.submitted = false;
            // Reset the form model.
            vm.data = {
                moneda:"0",
                tipoImpuesto: 0,
                codigoTarifa: 0,
                servicioId: 0,
                cantidad: 1
            };
            // Set back to pristine.
            $scope.dataForm.$setPristine();
            // Since Angular 1.3, set back to untouched state.
            $scope.dataForm.$setUntouched();
        };

        function validateSelectProperty(property){
            if(vm.data[property] == 0){
                $scope.dataForm[property].$setValidity("different", false);
            }
            else{
                $scope.dataForm[property].$setValidity("different", true);
            }
        };

        function getTipoCambio()
        {
            if(vm.data.moneda == 'CRC')
            {
                return 1;
            }

            else if(vm.data.moneda == 'USD')
            {
                const tipoCambio = vm.indicadores.find((i)=>i.id == 318);

                return tipoCambio.valor;               
            }

            return 0;

        }

        function getDolarValue()
        {
            const tipoCambio = vm.indicadores.find((i)=>i.id == 318);

            return tipoCambio.valor;
        }

        vm.onSelectChanged = function(property){
            validateSelectProperty(property);

            if(property == 'servicioId' && vm.data.servicioId != 0)
            {
                const s = vm.servicios.find(s=>s.id == vm.data.servicioId);

                if(s)
                {
                    vm.data.nombre = s.nombre;
                    vm.data.moneda = s.moneda;
                    vm.data.precioUnitario = s.precioUnitario;
                    vm.data.tipoImpuesto = s.tipoImpuesto;
                    vm.data.codigoTarifa = s.codigoTarifa;
                    vm.data.tarifa = s.tarifa;

                    if(vm.data.moneda != vm.contrato.moneda)
                    {
                        logger.info('Moneda del Servicio cambiada por el Contrato!');
                        vm.data.moneda = vm.contrato.moneda;
                        vm.data.tipoCambio = getTipoCambio();

                        if(vm.data.moneda == 'CRC')
                        {
                            vm.data.precioUnitario *= getDolarValue();
                        }
                        else if(vm.data.moneda == 'USD')
                        {
                            vm.data.precioUnitario /= getDolarValue();
                        }
                    }
                    else
                    {
                        vm.data.tipoCambio = getTipoCambio();
                    }
                }
            }

            if(property == 'moneda')
            {
                vm.data.tipoCambio = getTipoCambio();
            }
        };

    }
})();